import * as React from 'react'
import Box from '@mui/material/Box'
import Profile from '../../images/profile.png'

export default function MainAvatar () {
  return (
    <Box
      component="img"
      src={Profile}
      alt="Hyunjin Jae"
      sx={{
        width: 180,
        height: 180,
        objectFit: 'cover',
        borderRadius: 4,
        boxShadow: '1px 6px 8px 1px rgba(0, 0, 0, 0.2), 0 6px 50px 5px rgba(0, 0, 0, 0.19)'
      }}
    />
  )
}
